import React from 'react';
import Hero from './home/Hero';
import QuienesSomos from './home/QuienesSomos';
import NuestrasEmpresas from './home/NuestrasEmpresas';
import Galeria from './home/Galeria';
import Indicadores from './home/Indicadores';

function HeroSection1() {
  return (
    <main>
      <Hero />
      <QuienesSomos />
      <NuestrasEmpresas />
      
      <Indicadores />
      <Galeria />
    </main>
  );
}

export default HeroSection1;